'use strict'

const u = require('universalify').fromCallback
const rimraf = require('./rimraf')

module.exports = {
  remove: u(rimraf),
  removeSync: rimraf.sync
}



//////////////////
// WEBPACK FOOTER
// ./~/ethpm/~/fs-extra/lib/remove/index.js
// module id = 490
// module chunks = 0 1